/**
 * Warranties Landing - tabbed layout for warranty management pages.
 *
 * Tabs: Warranty Templates · Policies · Rules · Proration Formulas · Categories · Terms
 * Tab labels and page title use i18n so tenants can customise
 * (e.g. Supagard overrides "Warranty" → "Guarantee" via translations).
 */

import { AppShell } from '@/admin/components/app-shell'
import { useOrg } from '@/admin/hooks/use-org'
import { FLAGS, useFeatureFlag } from '@/admin/hooks/use-feature-flag'
import { Tab } from '@/shared/components/ui/tab'
import { Outlet } from 'react-router'
import { useTranslation } from 'react-i18next'

export function GuaranteesLandingPage() {
  const { t } = useTranslation()
  const { isLoading } = useOrg()
  const policiesTabEnabled = useFeatureFlag(FLAGS.POLICIES_TAB)
  const prorationFormulasEnabled = useFeatureFlag(FLAGS.PRORATION_FORMULAS)

  if (isLoading) return null

  const tabs = [
    { label: t('warrantyClasses.title', 'Warranty Templates'), path: '/manage/warranties/templates' },
    policiesTabEnabled
      ? { label: t('warrantyPolicies.title', 'Policies'), path: '/manage/warranties/policies' }
      : {
          label: t('warrantyMappings.title', 'Warranty Mappings'),
          path: '/manage/warranties/mappings',
        },
    { label: t('warrantyFiltering.title', 'Rules'), path: '/manage/warranties/filtering' },
    ...(prorationFormulasEnabled
      ? [{ label: t('prorationFormulas.title', 'Proration Formulas'), path: '/manage/warranties/proration' }]
      : []),
    { label: t('warrantyCategories.title', 'Categories'), path: '/manage/warranties/categories' },
    { label: t('warrantyTerms.title', 'Terms & Conditions'), path: '/manage/warranties/terms' },
  ]

  return (
    <AppShell>
      <main className="page-container py-10">
        <div data-tour="proration-header">
          <h1 className="clara-title mb-6">{t('manage.guaranteesSection', 'Warranties')}</h1>
          <Tab tabs={tabs} />
        </div>
        <Outlet />
      </main>
    </AppShell>
  )
}
